import React, { Fragment, ReactNode, useEffect, useState } from 'react';
import { Modal } from '../../../../core/components/templates/Modal';
import { Typography } from '../../../../core/components/molecules/Typography';
import { Button } from '../../../../core/components/atoms/Button';
import { LoadingIcon } from 'morpheus-ui';
import Checkbox from '../../../../core/components/atoms/Checkbox';
import { useGetUserCredit } from '../../hooks/getUserCredits';
import { practiceDetailStore } from '../../stores/practiceDetailsStore';

interface IConfirmationModal {
  text: string;
  onClose: () => void;
  onConfirm: () => void;
  isOpen: boolean;
  isByTime: boolean;
  loading?: boolean;
  warns?: ReactNode;
  hasWarn?: boolean;
  buttonOkText?: string;
  buttonCancelText?: string;
  isTextSent?: boolean;
}

const ConfirmationModal: React.FC<IConfirmationModal> = ({
  text,
  onClose,
  onConfirm,
  isOpen,
  isByTime,
  loading,
  warns,
  hasWarn = false,
  buttonCancelText,
  buttonOkText,
  isTextSent = false,
}) => {
  const { practice } = practiceDetailStore();
  const { mutate: userCredits, data: credits, isPending } = useGetUserCredit();

  const [isAware, setIsAware] = useState<boolean>(false);

  useEffect(() => {
    if (practice?.hasEssay) {
      userCredits();
    }
  }, [practice]);

  const HasCreditSuccess = () => (
    <Fragment>
      <Typography>{text}</Typography>
      <Typography>
        Ao finalizar o simulado, a sua redação será enviada para correção e{' '}
        <strong>1 crédito será descontado</strong>.
      </Typography>
      <Checkbox
        onChange={() => setIsAware(!isAware)}
        checked={isAware}
        label='Estou ciente de que minha redação será enviada para correção e de que não é possível desfazer essa ação.'
        id='essay-aware'
        value='essay-aware'
        disabled={credits?.remainingCreditsMonth === 0}
      />
    </Fragment>
  );

  const HasntCreditSuccess = () => (
    <Fragment>
      <Typography>
        <strong className='text-feedback-color-error-pure'>ATENÇÃO:</strong>
        Você não possui créditos suficientes para enviar esta redação para
        correção.
      </Typography>
      <Typography>
        A redação ficará salva como rascunho e você poderá acessá-la pela área
        de Redação do menu.
      </Typography>
      <Typography>{text}</Typography>
    </Fragment>
  );

  const NoTimeHasCredit = () => (
    <Fragment>
      <Typography>
        <b> Tempo esgotado! </b>Deseja finalizar o simulado com XX questões sem
        resposta.
      </Typography>
      <Typography>
        Se você finalizar o simulado, essas questões serão consideradas erradas.
      </Typography>
      <Typography>
        Ao finalizar o simulado, a sua redação será enviada para correção e{' '}
        <strong>1 crédito será descontado</strong>.
      </Typography>
      <Checkbox
        onChange={() => setIsAware(!isAware)}
        checked={isAware}
        label='Estou ciente de que minha redação será enviada para correção e de que não é possível desfazer essa ação.'
        id='essay-aware'
        value='essay-aware'
        disabled={credits?.remainingCreditsMonth === 0}
      />
    </Fragment>
  );

  const NoTimeHasntCredit = () => (
    <Fragment>
      <Typography>
        <b> Tempo esgotado! </b>Deseja finalizar o simulado com XX questões sem
        resposta.
      </Typography>
      <Typography>
        Se você finalizar o simulado, essas questões serão consideradas erradas.
      </Typography>
      <Typography>
        <strong className='text-feedback-color-error-pure'>ATENÇÃO:</strong>
        Você não possui créditos suficientes para enviar esta redação.
      </Typography>
      <Typography>
        A redação ficará salva como rascunho e você poderá acessá-la pela área
        de Redação do menu.
      </Typography>
    </Fragment>
  );

  const NoTimeHasCreditHasntWarn = () => (
    <Fragment>
      <Typography>
        <b> Tempo esgotado! </b>
      </Typography>
      <Typography>
        Se você finalizar o simulado, essas questões serão consideradas erradas.
      </Typography>
      <Typography>
        Ao finalizar o simulado, a sua redação será enviada para correção e{' '}
        <strong>1 crédito será descontado</strong>.
      </Typography>
      <Checkbox
        onChange={() => setIsAware(!isAware)}
        checked={isAware}
        label='Estou ciente de que minha redação será enviada para correção e de que não é possível desfazer essa ação.'
        id='essay-aware'
        value='essay-aware'
        disabled={credits?.remainingCreditsMonth === 0}
      />
    </Fragment>
  );

  const NoTimeHasntCreditHasntWarn = () => (
    <Fragment>
      <Typography>
        <b> Tempo esgotado! </b>
      </Typography>
      <Typography>
        Se você finalizar o simulado, essas questões serão consideradas erradas.
      </Typography>
      <Typography>
        <strong className='text-feedback-color-error-pure'>ATENÇÃO:</strong>
        Você não possui créditos suficientes para enviar esta redação.
      </Typography>
      <Typography>
        A redação ficará salva como rascunho e você poderá acessá-la pela área
        de Redação do menu.
      </Typography>
    </Fragment>
  );

  const WarnHasCredit = () => (
    <Fragment>
      {warns && warns}
      <Typography>
        Ao finalizar o simulado, a sua redação será enviada para correção e{' '}
        <strong>1 crédito será descontado</strong>.
      </Typography>
      <Checkbox
        onChange={() => setIsAware(!isAware)}
        checked={isAware}
        label='Estou ciente de que minha redação será enviada para correção e de que não é possível desfazer essa ação.'
        id='essay-aware'
        value='essay-aware'
        disabled={credits?.remainingCreditsMonth === 0}
      />
    </Fragment>
  );

  const WarnHasntCredit = () => (
    <Fragment>
      {warns && warns}
      <Typography>
        <strong className='text-feedback-color-error-pure'>ATENÇÃO:</strong>
        Você não possui créditos suficientes para enviar esta redação.
      </Typography>
      <Typography>
        A redação ficará salva como rascunho e você poderá acessá-la pela área
        de Redação do menu.
      </Typography>
      <Typography>{text}</Typography>
    </Fragment>
  );

  const SuccessModal = () => (
    <Fragment>
      <Typography>{text}</Typography>
    </Fragment>
  );

  const NoTime = () => (
    <Fragment>
      <Typography>
        <b> Tempo esgotado! </b>Deseja finalizar o simulado com XX questões sem
        resposta.
      </Typography>
      <Typography>
        Se você finalizar o simulado, essas questões serão consideradas erradas.
      </Typography>
    </Fragment>
  );

  const NoTimeSuccess = () => (
    <Fragment>
      <Typography>
        <b> Tempo esgotado! </b>Deseja finalizar o simulado?
      </Typography>
    </Fragment>
  );

  const contentChooser = () => {
    if (!practice?.hasEssay || (practice?.hasEssay && isTextSent)) {
      if (!hasWarn && !isByTime) {
        return <SuccessModal />;
      }

      if (hasWarn && !isByTime) {
        return <Fragment>{warns && warns}</Fragment>;
      }

      if (!hasWarn && isByTime) {
        return <NoTimeSuccess />;
      }

      if (hasWarn && isByTime) {
        return <NoTime />;
      }
    } else {
      if (!hasWarn && credits?.remainingCreditsMonth === 0 && !isByTime) {
        return <HasntCreditSuccess />;
      }

      if (!hasWarn && credits?.remainingCreditsMonth > 0 && !isByTime) {
        return <HasCreditSuccess />;
      }

      if (hasWarn && credits?.remainingCreditsMonth === 0 && !isByTime) {
        return <WarnHasntCredit />;
      }

      if (hasWarn && credits?.remainingCreditsMonth > 0 && !isByTime) {
        return <WarnHasCredit />;
      }

      if (hasWarn && credits?.remainingCreditsMonth === 0 && isByTime) {
        return <NoTimeHasntCredit />;
      }

      if (!hasWarn && credits?.remainingCreditsMonth === 0 && isByTime) {
        return <NoTimeHasntCreditHasntWarn />;
      }

      if (hasWarn && credits?.remainingCreditsMonth > 0 && isByTime) {
        return <NoTimeHasCredit />;
      }

      if (!hasWarn && credits?.remainingCreditsMonth > 0 && isByTime) {
        return <NoTimeHasCreditHasntWarn />;
      }
    }
  };

  const disableFinish = () => {
    if (practice?.hasEssay && isTextSent) {
      return false;
    }

    return practice?.hasEssay && !isAware;
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={() => onClose()}
      position='center'
      className='p-0 xs:w-full lg:w-2/5'
    >
      <div className='flex flex-col gap-xl'>
        {isPending ? (
          <LoadingIcon className='stroke-current h-10 animate-spin fill-none text-center' />
        ) : (
          contentChooser()
        )}
        <div className='flex flex-row items-center justify-end gap-sm'>
          <Button loading={loading} variant='text' onClick={() => onClose()}>
            <Typography>
              {!isByTime && buttonCancelText
                ? buttonCancelText
                : 'Continuar respondendo'}
            </Typography>
          </Button>
          <Button
            loading={loading}
            variant='text'
            disabled={disableFinish()}
            onClick={() => onConfirm()}
          >
            {buttonOkText ? buttonOkText : 'Continuar'}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default ConfirmationModal;
